var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeUnmute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 63 70",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.4993 48.8536C52.0327 48.8536 51.5952 48.7078 51.1868 48.4161C50.2243 47.687 50.0202 46.3161 50.7493 45.3536C54.4243 40.4536 55.2118 33.9495 52.8493 28.3203C52.3827 27.212 52.9077 25.9286 54.016 25.462C55.1243 24.9953 56.4077 25.5203 56.8743 26.6286C59.8493 33.687 58.8285 41.8828 54.2493 48.0078C53.8118 48.562 53.1702 48.8536 52.4993 48.8536Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9496 37.8004C42.7871 35.9629 45.9371 37.2754 45.9371 39.8712V48.4171C45.9371 53.4337 44.1287 57.1962 40.8912 59.0046C39.5787 59.7337 38.1204 60.0837 36.6037 60.0837C34.2704 60.0837 31.7621 59.2962 29.1954 57.6921L27.3287 56.5254C25.7537 55.5337 25.4912 53.3171 26.8037 52.0046L40.9496 37.8004Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.496 6.50391C62.621 5.62891 61.1918 5.62891 60.3168 6.50391L45.8793 20.9414C45.7043 16.2747 43.9543 12.7747 40.8627 11.0539C37.596 9.24557 33.4252 9.71224 29.1668 12.3664L20.6793 17.6747C20.096 18.0247 19.4252 18.2289 18.7543 18.2289H16.0418H14.5835C7.52516 18.2289 3.646 22.1081 3.646 29.1664V40.8331C3.646 47.8914 7.52516 51.7706 14.5835 51.7706H15.0502L6.47516 60.3456C5.60016 61.2206 5.60016 62.6497 6.47516 63.5247C6.94183 63.9331 7.496 64.1664 8.07933 64.1664C8.66266 64.1664 9.21683 63.9331 9.65433 63.4956L63.496 9.65391C64.4002 8.77891 64.4002 7.37891 63.496 6.50391Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeUnmute);
export default __webpack_public_path__ + "static/media/volume-unmute.56a84975fecc001b169e5611c9bb1a18.svg";
export { ForwardRef as ReactComponent };